"use client";
import React, {useEffect, useState} from "react";
import {GlobalFrontendConfiguratorContext} from "../ProductConfigurator/context";
import ProductGallery from "../ProductGallery/ProductGallery";
import ProductConfigureBuy from "../ProductConfigureBuy/ProductConfigureBuy";
import ProductGalleryPopup from "../ProductGallery/ProductGalleryPopup";
import {trackPixelViewContent} from "../../actions";
import {pixelEvent} from "../FBPixel/pixel";

const ProductMainBox = ({product, storeCode, config, takeMeasuresLink = null, _t}) => {


    //const productConfData = await apiFetcher(...getProductConfData(productId, null, storeCode)).then(res => normalizeProductConfData(res));

    const [curMedia, setCurMedia] = useState(null);
    const [galleryOpen, setGalleryOpen] = useState(false);


    useEffect(() => {
        trackPixelViewContent(product.sku,1,config?.store?.base_currency_code || 'eur').then(infoRes => {
            pixelEvent('ViewContent', infoRes);
        });
    }, []);

    const handleSetCurMedia = (entry) => {
        let newMedia = null;
        if (entry.media_type === 'external-video') {
            if (entry.extension_attributes && entry.extension_attributes.video_content && entry.extension_attributes.video_content) {
                //setVideoContent(entry.extension_attributes.video_content);
                newMedia = {
                    type: 'video',
                    file: entry.file,
                    video: entry.extension_attributes.video_content.video_url
                }
            }
        } else {
            newMedia = {
                type: 'image',
                file: entry.file
            }
            // setCurImage(entry.file);
        }
        setCurMedia(newMedia);
    }


    const handleGalleryToggle = (e) => {
        e.stopPropagation();
        if (!galleryOpen) {
            if (document) {
                document.getElementsByTagName('html')[0].style.overflow = 'hidden';
            }
        } else {
            if (document) {
                document.getElementsByTagName('html')[0].style.overflow = 'auto';
            }
        }
        setGalleryOpen(!galleryOpen);
    }

    return <div className={`flex flex-col lg:flex-row`}>
        <div className='w-full xl:w-auto lg:min-w-[534px] relative'>
            <div className={'md:sticky w-full lg:top-48 lg:left-0 z-10'}>
                <ProductGallery product={product} curMedia={curMedia} handleSetCurMedia={handleSetCurMedia}
                                handleGalleryToggle={handleGalleryToggle}/>

            </div>
            {galleryOpen &&
                <ProductGalleryPopup
                    product={product}
                    curMedia={curMedia}
                    handleSetCurMedia={handleSetCurMedia}
                    galleryOpen={galleryOpen}
                    handleGalleryToggle={handleGalleryToggle}
                    _t={_t}
                />}
        </div>
        <GlobalFrontendConfiguratorContext>

            <ProductConfigureBuy
                product={product}
                storeCode={storeCode}
                config={config}
                takeMeasuresLink={takeMeasuresLink}
                _t={_t}/>
        </GlobalFrontendConfiguratorContext>
    </div>
}

export default ProductMainBox;